// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_il-0";
export var animationContainer = "_il-1";
export var itemPrice = "_il-a";
export var itemizedContent = "_il-9";
export var itemizedHeader = "_il-7";
export var itemizedRow = "_il-8";
export var itemizedSection = "_il-6";
export var modalContent = "_il-2";
export var orderName = "_il-3";
export var refundOption = "_il-4";
export var refundOptionsContainer = "_il-5";
export var shippingLabel = "_il-b";
export var totalRow = "_il-c";